"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppHostUrl = exports.getAppFullUrl = exports.getAppUrl = void 0;

const getAppUrl = ({
  url,
  host,
  prefix,
  includeHost
}) => {
  const appUrl = "".concat(prefix).concat(url);

  if (includeHost) {
    return "".concat(host).concat(appUrl);
  }

  return appUrl;
};

exports.getAppUrl = getAppUrl;

const getAppFullUrl = ({
  url,
  host,
  prefix
}) => "".concat(host).concat(prefix).concat(url);

exports.getAppFullUrl = getAppFullUrl;

const getAppHostUrl = ({
  url,
  host
}) => "".concat(host).concat(url);

exports.getAppHostUrl = getAppHostUrl;